import { useMemo, useReducer, useState } from 'react'
import { useAlert } from 'react-alert'
import {
  IconDownloadSvg,
  IconEditSvg,
  IconTrashSvg
} from '../../../presentation/assets/icons/svgComponents'
import ImportFileModal from '../../../presentation/components/test-card/import-file-modal'
import InputModal from '../../../presentation/components/test-card/import-file-modal/input-modal'
import { useModalBox } from '../../../presentation/contexts'
import { formatDate } from '../../../presentation/utils'
import { deleteFile, uploadFile } from '../../usecases/Import-files'
type Props = {
  cdBloco: string
  cdPsicologo: string
  uploads: any
}

const ImportFileModalFactory = ({ cdBloco, cdPsicologo, uploads }: Props) => {
  const { modalBox, setTitle } = useModalBox()
  const alert = useAlert()
  const { modalClose } = useModalBox()
  const [page, setPage] = useState(0)
  const [file, setFile] = useState<string | ArrayBuffer | null>()
  const [fileName, setFileName] = useState<string>()
  const initialState = uploads
  const [disable, setDisable] = useState(true)
  const reducer = (state: any, action: any) => {
    switch (action.type) {
      case 'set':
        return action.newState
      default:
        return uploads
    }
  }
  const [allUploads, dispatch] = useReducer(reducer, initialState)
  const columns = useMemo(
    () => [
      {
        Header: 'Data de upload',
        accessor: 'uploadDate'
      },
      {
        Header: 'Formato',
        accessor: 'format'
      },
      {
        Header: 'Descrição',
        accessor: 'description'
      },
      {
        Header: '',
        accessor: 'actions'
      }
    ],
    []
  )
  const data = useMemo(() => {
    return allUploads?.map((item: any) => {
      return {
        format: item?.type,
        description: item?.descricao,
        uploadDate: formatDate(item?.uploadAt),
        actions: (
          <div className="table-icons">
            <a href={item.url} title="Download">
              <IconDownloadSvg />
            </a>
            <div
              onClick={async () => {
                try {
                  const newState = await deleteFile(
                    cdBloco,
                    item.cdUpload
                  ).delete()
                  dispatch({ type: 'set', newState: newState })
                  alert.show('Sucesso ao deletar o arquivo', {
                    type: 'success',
                    timeout: 4000
                  })
                } catch (error) {
                  alert.show('Erro ao deletar o arquivo', {
                    type: 'error',
                    timeout: 4000
                  })
                }
              }}
            >
              <IconTrashSvg />
            </div>
            <div
              onClick={() => {
                modalBox(<InputModal item={item} />, 'Mudar descrição', '42%')
              }}
            >
              <IconEditSvg />
            </div>
          </div>
        )
      }
    })
  }, [alert, allUploads, cdBloco, modalBox])
  const handleSave = () => {
    try {
      uploadFile(cdPsicologo, cdBloco).update([
        { descricao: fileName, path: file }
      ])
      alert.show('Sucesso em anexar o arquivo', {
        type: 'success',
        timeout: 4000
      })
      modalClose()
    } catch (error) {
      alert.show('Erro em anexar o arquivo', {
        type: 'error',
        timeout: 4000
      })
    }
  }
  const handleFileChange = (e: any) => {
    setFileName(
      !!e?.target?.files && e?.target?.files[0].name
        ? e.target.files[0].name
        : 'Escolha um arquivo'
    )
    if (e.target.files[0].size > 5000000) {
      alert.show('Arquivo maior que 5mb', {
        type: 'error',
        timeout: 4000
      })
      setDisable(true)
    } else {
      e.target?.files[0] ? setDisable(false) : setDisable(true)
    }
    const reader = new FileReader()
    const file = (!!e?.target?.files && e?.target?.files[0]) || null
    if (file) {
      reader.readAsDataURL(file)
      reader.onload = () => {
        setFile(reader.result)
      }
      reader.onerror = (error) => {
        console.error('Error: ', error)
      }
    }
  }

  return (
    <ImportFileModal
      disable={disable}
      uploads={uploads}
      page={page}
      setPage={setPage}
      fileName={fileName}
      cdBloco={cdBloco}
      cdPsicologo={cdPsicologo}
      handleSave={handleSave}
      handleFileChange={handleFileChange}
      columns={columns}
      data={data}
      setTitle={setTitle}
    />
  )
}
export default ImportFileModalFactory
